import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  LogControllerDtoResetStatsLogListRequest,
  PerplayLogApi,
} from '../../models/src';
import {
  RESETSTATSLOG_LIST_REQUEST
} from '../../constants/log/resetStatsLogConstants';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import LogControllerDtoResetStatsLogListResponse
  from '../../models/src/model/LogControllerDtoResetStatsLogListResponse';

const api = new PerplayLogApi(config.API_CLIENT);

function* resetStatsLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoResetStatsLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.account = payload.account;
    requestData.nftUid = payload.nftUid;
    requestData.walletTransactionNo = payload.walletTransactionNo;
    console.log('requestData: ', requestData);

    const result = yield api.apiPerplayLogResetStatsLogListPost({ logControllerDtoResetStatsLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoResetStatsLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* resetStatsLogRootSaga() {
  yield all([
    takeEvery(RESETSTATSLOG_LIST_REQUEST, resetStatsLogListRequestSaga),
  ]);
}

const resetStatsLogSaga = [
  fork(resetStatsLogRootSaga),
]

export default resetStatsLogSaga;
